import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import {Checkbox, InputField} from '../../../InputForms';
import {TextButton, Icon, IconTypes} from '../../../Buttons';
import styles from './style.css';


export function getInitialTextForm() {
    return {
        inputElementType: 'TEXTBOX',
        inputElement: {
            textbox: {
                label: '',
                placeholder: '',
                goldenText: '',
                isMultiline: false
            }
        }
    }
}

export function getInitialChecklistForm() {
    return {
        inputElementType: 'QUESTION',
        inputElement: {
            question: {
                text: '',
                questionType: 'SINGLE_CHOICE',
                questionAnswers: []
            }
        }
    }
}

export function getInitialDropwdownForm() {
    return {
        inputElementType: 'QUESTION',
        inputElement: {
            question: {
                text: '',
                questionType: 'DROPDOWN',
                questionAnswers: []
            }
        }
    }
}

class SelectableAnswer {
    constructor(answer='', isGolden=false) {
        this.answer = answer
        this.isGolden = isGolden
    }
}

const Form = inject('localizationStore')(observer(({localizationStore, index, state, onDeleteForm, onInputChange}) => {
    let name, form
    if (state.textbox) {
        name = localizationStore.locale.textForm
        form = <TextForm index={index} state={state.textbox} onStateChange={onInputChange} />
    }
    if (state.question) {
        if (state.question.questionType === 'DROPDOWN') {
            name = localizationStore.locale.dropdownForm
            form =  <DropdownForm index={index} state={state.question} onStateChange={onInputChange} />
        }
        if (['SINGLE_CHOICE', 'MULTIPLE_CHOICE'].includes(state.question.questionType)) {
            name = localizationStore.locale.checklistForm
            form = <ChecklistForm index={index} state={state.question} onStateChange={onInputChange} />
        }
    }
    return (
        <div className={styles.formBox}>
            <Icon type={IconTypes.clear} style={styles.removeIcon} onClick={onDeleteForm} />
            <span className={styles.formName}>{name}</span>
            {form}
        </div>
    );
}))

const TextForm = inject('localizationStore')(observer(
    ({localizationStore, index, state, onStateChange}) => {
        const locale = localizationStore.locale
        const onInputChanged = (event) => {
            let nextState = state
            if(event.target.type === 'checkbox'){
                nextState[event.target.name] = event.target.checked
            }
            else{
                nextState[event.target.name] = event.target.value
            }
            onStateChange(nextState)
        }
        const {label, placeholder, goldenText, isMultiline} = state
        return (
            <div className={styles.form}>
                <IndexField index={index} onSubmit={(newIndex) => onStateChange(state, newIndex)}/>
                <InputField style={styles.inputBox}
                            required
                            value={label}
                            name='label'
                            placeholder={locale.label}
                            onChange={onInputChanged}
                />
                <InputField style={styles.inputBox}
                            required
                            value={placeholder}
                            name='placeholder'
                            placeholder={locale.placeholder}
                            onChange={onInputChanged}
                />
                <InputField style={styles.inputBox}
                            value={goldenText}
                            name='goldenText'
                            placeholder={locale.goldenText}
                            onChange={onInputChanged}
                />
                <Checkbox style={styles.inputBox}
                          checked={isMultiline}
                          name='isMultiline'
                          label={locale.multiline}
                          onChange={onInputChanged}
                />

            </div>
        );
}))

const ChecklistForm = inject('localizationStore')(observer(
    ({localizationStore, index, state, onStateChange}) => {
        const locale = localizationStore.locale
        const onAddOptionClick = () => {
            let nextState = state
            nextState.questionAnswers.push(new SelectableAnswer())
            onStateChange(nextState)
        }
        const onDeleteOptionClick = (index) => {
            let nextState = state
            nextState.questionAnswers.splice(index, 1)
            onStateChange(nextState)
        }
        const onInputChanged = (event) => {
            let nextState = state
            if(event.target.name === 'isMultipleChoice'){
                if(!event.target.checked){
                    nextState.questionAnswers.forEach(a => {a.isGolden = false})
                }
                nextState.questionType = event.target.checked ? 'MULTIPLE_CHOICE' : 'SINGLE_CHOICE'
            }
            else{
                nextState[event.target.name] = event.target.value
            }
            onStateChange(nextState)
        }
        const onOptionChanged = (event, index) => {
            let nextState = state
            if(event.target.type === 'checkbox'){
                if(!state.isMultipleChoice){
                    nextState.questionAnswers.forEach(a => {a.isGolden = false})
                }
                nextState.questionAnswers[index].isGolden = event.target.checked
            }
            else{
                nextState.questionAnswers[index].answer = event.target.value
            }
            onStateChange(nextState)
        }
        return (
            <div className={styles.form}>
                <IndexField index={index} onSubmit={(newIndex) => onStateChange(state, newIndex)}/>
                <InputField style={styles.inputBox}
                            required
                            value={state.text}
                            name='text'
                            placeholder={locale.text}
                            onChange={onInputChanged}
                />
                <Checkbox style={styles.inputBox}
                          checked={state.isMultipleChoice}
                          name='isMultipleChoice'
                          label={locale.multipleChoice}
                          onChange={onInputChanged}
                />
                <OptionsList questionAnswers={state.questionAnswers}
                             onOptionChanged={onOptionChanged}
                             onDeleteOptionClick={onDeleteOptionClick}
                             onAddOptionClick={onAddOptionClick}
                />
            </div>
        );
}))

const DropdownForm  = inject('localizationStore')(observer(
    ({localizationStore, index, state, onStateChange}) => {
        const locale = localizationStore.locale
        const onAddOptionClick = () => {
            let nextState = state
            nextState.questionAnswers.push(new SelectableAnswer())
            onStateChange(nextState)
        }
        const onDeleteOptionClick = (index) => {
            let nextState = state
            nextState.questionAnswers.splice(index, 1)
            onStateChange(nextState)
        }
        const onInputChanged = (event) => {
            let nextState = state
            nextState.text = event.target.value
            onStateChange(nextState)
        }
        const onOptionChanged = (event, index) => {
            let nextState = state
            if(event.target.type === 'checkbox'){
                nextState.questionAnswers.forEach(a => {a.isGolden = false})
                nextState.questionAnswers[index].isGolden = event.target.checked
            }
            else{
                nextState.questionAnswers[index].answer = event.target.value
            }
            onStateChange(nextState)
        }
        return (
            <div className={styles.form}>
                <IndexField index={index} onSubmit={(newIndex) => onStateChange(state, newIndex)}/>
                <InputField style={styles.inputBox}
                            required
                            value={state.text}
                            name='text'
                            placeholder={locale.text}
                            onChange={onInputChanged}
                />
               <OptionsList questionAnswers={state.questionAnswers}
                            onOptionChanged={onOptionChanged}
                            onDeleteOptionClick={onDeleteOptionClick}
                            onAddOptionClick={onAddOptionClick}
               />
            </div>
        );
}))

const OptionsList  = inject('localizationStore')(observer(
    ({localizationStore, questionAnswers, onOptionChanged, onDeleteOptionClick, onAddOptionClick}) => {
        const locale = localizationStore.locale
        return (
            <div className={styles.inputBox}>
                <div>{locale.answer_options}:</div>
                {questionAnswers.map((a, i) => {return (
                    <div className={styles.option} key={i}>
                        <Checkbox checked={questionAnswers[i].isGolden}
                                  onChange={(e) => onOptionChanged(e, i)}
                        />
                        <InputField value={questionAnswers[i].answer}
                                    required
                                    placeholder={locale.option}
                                    onChange={(e) => onOptionChanged(e, i)}
                        />
                        <Icon type={IconTypes.delete} onClick={() => onDeleteOptionClick(i)} />
                    </div>
                )})}
                <Icon type={IconTypes.add} style={styles.option} onClick={onAddOptionClick} />
            </div>
        );
}))

const IndexField = inject('localizationStore')(observer(class IndexField extends Component {
    constructor(props) {
        super()
        this.state = {
            indexValue: props.index,
            error: null
        }
    }

    setIndexValue = (e) => { this.setState({indexValue: e.target.value})}

    changeIndex = (e) => {
        try {
            const index = parseInt(this.state.indexValue, 10)
            if (index < 1 || isNaN(index)) {
                throw Error(this.props.localizationStore.locale.wrong_index)
            }
            this.props.onSubmit(index)
            this.setState({error: null})
        } catch (error) {
            this.setState({error})
        }
    }

    cancel = (e) => {
        this.setState({indexValue: this.props.index})
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.index !== this.props.index) {
            this.setState({indexValue: this.props.index})
        }
    }

    render() {
        const locale = this.props.localizationStore.locale
        return (
            <div className={styles.indexField}>
                <InputField style={styles.inputBox}
                            required
                            value={this.state.indexValue}
                            name='index'
                            placeholder={locale.index}
                            onChange={this.setIndexValue}
                />
                <TextButton text={locale.set_index}
                            style={styles.setIndexButton}
                            onClick={this.changeIndex}
                />
                {this.state.indexValue !== this.props.index ? (
                    <React.Fragment>
                        <div className={styles.indexNotSet}>{locale.index_not_set}</div>
                        <TextButton text={locale.cancel}
                             style={styles.setIndexButton}
                                onClick={this.cancel}
                        />
                    </React.Fragment>
                    ) : null}
                {this.state.error ? <div className={styles.indexNotSet}>{this.state.error.message}</div>: null}
            </div>
        )
    }
}))

export default Form;


// WEBPACK FOOTER //
// ./src/components/AddTaskModal/components/Form/index.js